module.exports = __webpack_public_path__ + "img/gucci.41fe767.svg";